import React from "react";

/**
 * useNotifyMobileModal
 *
 * When the section player runs inside the mobile app's WebView, a native
 * close (X) is painted at the top-right corner of the WebView (see
 * ModalBottomCompleteTrack.js). That X must hide whenever the web opens
 * one of its own modals (Quiz, Swipe Deck, Signature, Document Upload, …)
 * so the user's tap is unambiguously interpreted by the inner modal's
 * own close affordance.
 *
 * Pass the modal's `isOpen` state. The hook posts:
 *   - {type:'inner_modal_open'}   on rise (false → true) or initial mount when true
 *   - {type:'inner_modal_closed'} on fall (true → false) or unmount while open
 *
 * Native (ModalBottomCompleteTrack) maintains a counter — increment on open,
 * decrement on closed, clamp at 0 — and hides the X whenever counter > 0.
 * The counter shape supports nested modals (e.g. Quiz opens then Quiz Review
 * stacks on top).
 *
 * No-op in any context where window.ReactNativeWebView is undefined
 * (desktop browser, server render).
 */
export const useNotifyMobileModal = (isOpen) => {
  React.useEffect(() => {
    if (
      typeof window === "undefined" ||
      !window.ReactNativeWebView ||
      !isOpen
    ) {
      return undefined;
    }
    try {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "inner_modal_open" })
      );
    } catch (_) {}
    return () => {
      try {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "inner_modal_closed" })
        );
      } catch (_) {}
    };
  }, [isOpen]);
};
